// ==================== FILE: components/CustomerInfoPage/styles.js ====================
export const containerStyle = {
  backgroundColor: "#f5f5f5",
  minHeight: "100vh",
  padding: "24px",
};

export const spinContainerStyle = {
  ...containerStyle,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const alertContainerStyle = containerStyle;

export const cardStyle = {
  borderRadius: 8,
  marginBottom: 24,
  boxShadow: "0 1px 2px rgba(0,0,0,0.03), 0 1px 6px -1px rgba(0,0,0,0.02)",
};
